<h2 i18n>From idea to product</h2>
<p i18n>
  Your feedback helps our ideas grow into valuable features and products, like a seed growing into a mature plant,
  ensuring they meet users' needs and support their daily work.
</p>
<div class="levels-wrapper">
  <div>
    <div class="level">
      <img src="maturity-level/idea.png" i18n-alt alt="Idea" />
      <p i18n>A concept or description of a solution to a problem we would like to get your feedback on.</p>
    </div>
    <div class="level">
      <img src="maturity-level/prototype.png" i18n-alt alt="Prototype" />
      <p i18n>An early model of a solution. Your feedback will help us refine and improve the final solution.</p>
    </div>
    <div class="level">
      <img src="maturity-level/beta.png" i18n-alt alt="Beta" />
      <p i18n>Working feature ready for testing. Please let us know about your experience when using it.</p>
    </div>
    <div class="level">
      <img src="maturity-level/product.png" i18n-alt alt="Product" />
      <p i18n>Ready to use feature. Use it in your daily work and share your thoughts so we can continue to improve.</p>
    </div>
  </div>
  <img src="images/home_maturity.png" i18n-alt alt="Welcome" />
</div>
